/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trim_To_DurationInputs */

const en_trim_to_duration = /** @type {(inputs: Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trim to Duration`)
};

const fr_trim_to_duration = /** @type {(inputs: Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuster à la durée`)
};

const de_trim_to_duration = /** @type {(inputs: Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Dauer kürzen`)
};

const it_trim_to_duration = /** @type {(inputs: Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritaglia in base alla durata`)
};

const ru_trim_to_duration = /** @type {(inputs: Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обрезать до длительности`)
};

const es_trim_to_duration = /** @type {(inputs: Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recortar a duración`)
};

const zh_cn2_trim_to_duration = /** @type {(inputs: Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修剪至时长`)
};

const ja_trim_to_duration = /** @type {(inputs: Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`継続時間に合わせてトリム`)
};

const hi_trim_to_duration = /** @type {(inputs: Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवधि के अनुसार ट्रिम करें`)
};

const pt_pt2_trim_to_duration = /** @type {(inputs: Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar à duração`)
};

/**
* | output |
* | --- |
* | "Trim to Duration" |
*
* @param {Trim_To_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const trim_to_duration = /** @type {((inputs?: Trim_To_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trim_To_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_trim_to_duration(inputs)
	if (locale === "de") return de_trim_to_duration(inputs)
	if (locale === "it") return it_trim_to_duration(inputs)
	if (locale === "ru") return ru_trim_to_duration(inputs)
	if (locale === "es") return es_trim_to_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_trim_to_duration(inputs)
	if (locale === "ja") return ja_trim_to_duration(inputs)
	if (locale === "hi") return hi_trim_to_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_trim_to_duration(inputs)
	return en_trim_to_duration(inputs)
});